<template>
    <li class="calendar-nav-link"
        :class="classStr"  
    >
        <a :href="href"
          @click="$emit('click')"
          :class="{
            'active': isRoute,  //'btn-inverse'
            'disabled': isRoute,
          }"
          :disabled="isRoute"
        >
            <slot name="icon"><CalendarIcon v-if="useIcon" :force="useIcon" /></slot>
            <slot name="label"></slot>
        </a>
    </li>
</template>
<script>
import {ITEM_TYPES} from '@/components/Config';
// import ChevronRight from '@/components/icons/ChevronRight';
import {trackClasses} from '@/utils/Attributes';
import CalendarIcon from './CalendarIcon';

export default {
    name: "CalendarNavLink",
    props: {
        route: {
            type: String,
            required: true,
        },
        track: {
            type: Object,
            required: false,
        },
        icon: {
            type: String,
            required: false,
        }
    },
    components: {
        CalendarIcon,
        // ChevronRight,
    },
    computed: {
        href() {
            let curRoute;
            if (this.track) {
                // trackId values may include the falsy 0 for the 'Session' track
                curRoute = this.$router.resolve({ name: 'calendar-track', params: {trackId: this.trackId} });
            } else {
                curRoute = this.$router.resolve({ name: this.route });
            }
            return curRoute.href;
        },
        trackId() {
            if (this.track) { return this.track.id; }
            return null;
        },
        isRoute() {
            if (this.$route.name ==='calendar-track') {
                return this.$route.params.trackId == this.trackId;
            }
            return this.$route.name == this.route;
        },
        useIcon() {
            if (this.icon) {
                return this.icon;
            }
            if (this.track) {
                switch (this.trackId) {
                    case 'my':
                        return ITEM_TYPES.TICKETED;
                    default:
                        return ITEM_TYPES.APPOINTMENT;
                }
            }
            return null;
        },
        classStr() {
            var out = '';
            if (this.isRoute) {
                out = 'active ';
                // out = 'active disabled ';
            }
            if (this.track) {
                out += trackClasses(this.track);
            }
            return out;
        },
    },
}
</script>
<style>
:root {
    --col-nav-link: #0088cc;
}

.calendar-nav-link {
    padding: 0;
    /* padding: 0 10px; */
}

/* .calendar-nav-link.active {
    background-color: #0088cc;
} */

.calendar-nav-divider {
    *width: 100%;
    height: 1px;
    margin: 9px 1px;
    *margin: -5px 0 5px;
    overflow: hidden;
    background-color: #e5e5e5;
    border-bottom: 1px solid #ffffff;
}

.calendar-nav-header,
.calendar-nav-link a {
    color: #333;

    display: flex !important;
    flex-direction: row;
    gap: 5px;
    justify-content: space-between;
    align-items: flex-start; /* center; */
    /* padding: 8px 0 8px 5px; */
    padding: 8px;
    line-height: 16px;
    cursor: pointer;
}

.calendar-nav-link a:link,
.calendar-nav-link a:visited,
.calendar-nav-link a:hover,
.calendar-nav-link a:active
{
    text-decoration: none;
}
.calendar-nav-link a:hover,
.calendar-nav-link a:active
{
    background-color: #eeeeee;
}

.calendar-nav-link a.active,
.calendar-nav-link a.active:hover {
    color: #fff;
    background-color: var(--col-nav-link);
}

/* ICON COLOR OVERRIDES */
.calendar-nav-link a.active .calendar-nav, /* .calendar-nav is used for the Itinerary/Day/Week/Month icons */
.calendar-nav-link a.active .calendar-icon-appointment-confirmed,
.calendar-nav-link a.active .calendar-icon-meeting-confirmed {
    color: #fff;
}

.calendar-nav-header {
    display: block;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: bold;
    line-height: 20px;
    color: #999;
    /* text-shadow: 0 1px 0 rgb(255 255 255 / 50%); */
    text-transform: uppercase;
}
li.calendar-nav-link + .calendar-nav-header {
    margin-top: 10px;
}

</style>